import { supabase } from "../lib/supabase";
import { getCurrentUser, requireActiveWorkspaceId } from "./workspaceService";

export async function getCustomers() {
  const workspaceId = await requireActiveWorkspaceId();

  const { data, error } = await supabase
    .from("customers")
    .select("*")
    .eq("workspace_id", workspaceId)
    .order("name", { ascending: true });

  if (error) throw error;

  return data || [];
}

export async function createCustomer(customer) {
  const workspaceId = await requireActiveWorkspaceId();
  const user = await getCurrentUser();

  const payload = {
    ...customer,
    user_id: user.id,
    workspace_id: workspaceId,
  };

  const { data, error } = await supabase
    .from("customers")
    .insert(payload)
    .select("*")
    .single();

  if (error) throw error;

  return data;
}

export async function updateCustomer(customerId, patch) {
  const workspaceId = await requireActiveWorkspaceId();

  const { data, error } = await supabase
    .from("customers")
    .update(patch)
    .eq("id", customerId)
    .eq("workspace_id", workspaceId)
    .select("*")
    .single();

  if (error) throw error;

  return data;
}

export async function deleteCustomer(customerId) {
  const workspaceId = await requireActiveWorkspaceId();

  const { error } = await supabase
    .from("customers")
    .delete()
    .eq("id", customerId)
    .eq("workspace_id", workspaceId);

  if (error) throw error;

  return true;
}